import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, Response, ResponseContentType } from '@angular/http';
import 'rxjs/add/operator/map'; // add map function to observable
import 'rxjs/add/operator/catch';

import { environment } from '../../environments/environment';
import { AuthenticationService } from '.';
import * as FileSaver from 'file-saver';

@Injectable()
export class RestService {

    private articleURL = environment.apiURL + 'articles/';
    private trackingURL = environment.apiURL + 'trackings/';
    private ordersURL = environment.apiURL + 'orders/';
    private downloadURL =  environment.apiURL + 'resources/';

    constructor(
        private http: Http,
        private authenticationService: AuthenticationService) {
    }

    getArticles(businessKey: string, projectId: number) {
        let filter: string = 'order/projectId?orderBusinessKey=' + businessKey + '&projectId='+projectId;
        return this.http.get(this.articleURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get articles!"));
        });
    }

    getArticleState(businessKey: string) {
        let filter: string = 'state?businessKey=' + businessKey;
        return this.http.get(this.articleURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.text();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get article state!"));
        });
    }

    getArticlesState(businessKeyList: any[]) {
        let filter: string = 'states';
        return this.http.put(this.articleURL + filter, businessKeyList, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get articles states!"));
        });
    }

    createExportDEManifest(manifest: any, manifestNumberString: string) { // at the moment create importCH manifest, until we implement ExportDE Workflow
        let filter: string = "manifests/import/orders?isExportDE=true";
        return this.http.post(environment.apiURL + filter , manifest, {
            headers: this.authenticationService.getHeaderJsonByToken(environment.storageToken)
        })
        .map((res: Response) => {
            return res;
        })
        .catch((error: any) => {
            if (error.status == '500') {
                return Observable.throw(new Error("Could not generate Export DE manifest! TIME OUT!!!"));
            } else {
                try {
                    // Substract from "error" until the end and show as error message
                    let indexOfError = error._body.indexOf("error");            
                    return Observable.throw(new Error("Could not generate Export DE manifest! ERROR STATUS: " + error.status + " ERROR MESSAGE: " + error._body.substring(indexOfError + 7)));
                } catch (errorTimeOut) {
                    return Observable.throw(new Error("MANIFEST OK. The manifest " + manifestNumberString + " will be generated soon!"));
                }
            }
        }); 
    }

    createExportCHManifest(manifest: any, isEcomm: boolean, workflowCountry: string, manifestNumberString: string) { // at the moment create importCH manifest, until we implement ExportCH Workflow
        let isEcommReturn : string;
        if (isEcomm) { isEcommReturn = "true"; } else { isEcommReturn = "false"; }
        let filter: string = "manifests/export/orders?isEcommReturn="+isEcommReturn; 
        if (workflowCountry) {
            filter = filter + "&workflowCountry="+workflowCountry;
        }
        return this.http.post(environment.apiURL + filter , manifest, {
            headers: this.authenticationService.getHeaderJsonByToken(environment.storageToken)
        })
        .map((res: Response) => {
            return res;
        })
        .catch((error: any) => {
            if (error.status == '500') {
                return Observable.throw(new Error("Could not generate Export CH manifest! TIME OUT!!"));
            } else {
                try {
                    // Substract from "error" until the end and show as error message
                    let indexOfError = error._body.indexOf("error");            
                    return Observable.throw(new Error("Could not generate Export CH manifest! ERROR STATUS: " + error.status + " ERROR MESSAGE: " + error._body.substring(indexOfError + 7)));
                } catch (errorTimeOut) {
                    return Observable.throw(new Error("MANIFEST OK. The manifest " + manifestNumberString + " will be generated soon!"));
                }
            }
        }); 
    }

    getTracking(value: string) {
        let filter: string = encodeURIComponent(value);
        return this.http.get(this.trackingURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get tracking!"));
        });
    }

    getTrackingsByTrackingNumbers(trackingNumbers: string[]) {
        let filter: string = 'bulk/byTrackingNumbers';
        return this.http.post(this.trackingURL + filter, trackingNumbers, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get trackings by tracking numbers!"));
        });
    }

    getTrackings(reference: string, isLabel: boolean, itemType: string) {
        let filter: string = "?reference="+reference+"&isLabel="+isLabel+"&itemType="+itemType;
        return this.http.get(this.trackingURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get trackings!"));
        });
    }

/*
    getTrackings(reference: string, status: string, type: string, projectId: number) {
        let filter: string = "?reference=" + reference + "&status=" + status + "&itemType=" + type + "&projectId = " + projectId;
        return this.http.get(this.trackingURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get trackings!"));
        });
    }
*/

    getLabel(trackingNumber: string) {
        return this.http.get(this.downloadURL + environment.storageToken + '/labels/' + trackingNumber + '?mediaType=pdf', 
            {
                headers: this.authenticationService.getHeaderOctetByToken(environment.storageToken),
                responseType: ResponseContentType.Blob
            })
           .map((res: Response) => {
                let fileBlob = res.blob();
                let blob = new Blob([fileBlob], { 
                    type: 'application/octet-stream' // must match the Accept type
                });
                let filename = trackingNumber+'.pdf';
                FileSaver.saveAs(blob, filename); 
                return res.json();
        })
        .catch((error: any) => {
            return this.http.get(this.downloadURL + environment.storageToken + '/labels/' + trackingNumber + '?mediaType=png', 
                {
                    headers: this.authenticationService.getHeaderOctetByToken(environment.storageToken),
                    responseType: ResponseContentType.Blob
                })
               .map((res: Response) => {
                    let fileBlob = res.blob();
                    let blob = new Blob([fileBlob], { 
                        type: 'application/octet-stream' // must match the Accept type
                    });
                    let filename = trackingNumber+'.png';
                    FileSaver.saveAs(blob, filename); 
                    return res.json();
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not get label"));
            });
        });
    }


    doRelabeling(orderBusinessKey: string, trackingNumber: string): Observable<any> {
        const filter = `relabeling/${orderBusinessKey}/${trackingNumber}`;
        return this.http
          .put(this.ordersURL + filter, '', {
            headers: this.authenticationService.getHeader()
          })
          .map((res: Response) => res.json())
          .catch((error: any) => {
            console.error('REST doRelabeling failed:', error);
            // re-throw the original error so caller can inspect status/message
            return Observable.throw(error);
          });
    }


    getOrders(reference: string, projectId: number) {
        let filter: string = encodeURIComponent(reference) + '/' + projectId;
        return this.http.get(this.ordersURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get order!"));
        });
    }

    getOrderCustomersByReferences(orderReferences: any[]) {
        let filter: string = 'bulk/customers/byReferences';
        return this.http.post(this.ordersURL + filter, orderReferences, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get order customers by references!"));
        });
    }

    sendMogEvent(mogEvent: any) {
        let filter: string = "mog/orders";
        return this.http.post(environment.apiURL + filter , mogEvent, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res;
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not sendMogEvent!"));
        }); 
    }

    createEvent(event: any) {
        let filter: string = "events";
        return this.http.post(environment.apiURLV1 + filter , event, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res;
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not createEvent!"));
        }); 
    }

    sendEmail(jenkinsRequest: any) {
        let filter: string = "jenkins/build";
        return this.http.post(environment.apiURL + filter , jenkinsRequest, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res;
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not sendEmail!"));
        }); 
    }

    getTrackingItemInfo(trackingItemId: any) {
        let filter: string = 'trackingItemInfo/' + trackingItemId;
        return this.http.get(this.trackingURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get tracking item info!"));
        });
    }

    private handleError (error: Response | any) {
        let errMsg: string;
        if (error instanceof Response) {
            try {
                errMsg = error.json();
            } catch (e) {
                // No content response..
                errMsg = null;
            }
        }
        return Observable.throw(errMsg);
    }
    
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/services/rest.service.ts